
export enum MovementStatusEnum {
    New = 1,
    Dispatched = 2,
    InProgress = 3,
    Completed = 4,
    Held = 5,
    Planned = 6,
    Billed = 7,
    Failed = 8,
    Started = 9,
    Loading = 10,
    Driving = 11,
    Unloading = 12,
    Loaded = 13,
    Driven = 14,
    Unloaded = 15,
    Cancelled = 16,
    Onsite = 17,
    OnsiteDone = 18,
    Subcontractor = 19,
    Pool = 21
}